module.exports = __webpack_public_path__ + "img/consent-collection-widget-bottom-right.8c113d9d.svg";